import { styled } from '@ngw6/us-components';

export const StyledLoadingSpinnerContainer = styled.div`
  min-height: 200px;
`;

export const StyledAppContainer = styled.div`
  z-index: 0;
`;
